import { useTranslation } from 'react-i18next'
import { Link } from "react-router-dom"
import logoBB from "../assets/images/logoBD.png"
import LanguageSwitcher from "./LanguageSwitcher"

import { Fragment } from 'react'
import { Popover, Transition } from '@headlessui/react'
import { ChevronDownIcon } from '@heroicons/react/20/solid'
import { Bars3Icon,CursorArrowRaysIcon,PhoneIcon,XMarkIcon,CircleStackIcon,ShoppingBagIcon,PencilIcon,RectangleStackIcon } from '@heroicons/react/24/outline'

const Navbar = () => {
    const { t } = useTranslation()

    const services = [
        {
            name: 'nav_service_name1',
            description: 'nav_service_description1',
            href: '/services/websites',
            icon: CursorArrowRaysIcon,
        },
        {
          name: 'nav_service_name2',
          description: 'nav_service_description2',
          href: '/services/ecommerce',
          icon: ShoppingBagIcon,
        },
        { 
          name: 'nav_service_name3',
          description: "nav_service_description3",
          href: '/services/databases',
          icon: CircleStackIcon
        },
        {
          name: 'nav_service_name4',
          description: "nav_service_description4",
          href: '/services/graphic-design',
          icon: PencilIcon,
        },
    ]
    const callsToAction = [
        { name: 'nav_call_to_action1', href: '/portfolio', icon: RectangleStackIcon },
        { name: 'nav_call_to_action2', href: '/contact', icon: PhoneIcon },
    ]
    // const templates = [
    //     {
    //         name: 'nav_template_name1',
    //         description: 'nav_template_description1',
    //         href: '/templates/websites',
    //         icon: CursorArrowRaysIcon,
    //     },
    //     {
    //         name: 'nav_template_name2',
    //         description: 'nav_template_description2',
    //         href: '/templates/ecommerce',
    //         icon: ShoppingBagIcon,
    //     },
    //     {
    //         name: 'nav_template_name3',
    //         description: 'nav_template_description3',
    //         href: '/templates/databases',
    //         icon: CircleStackIcon,
    //     }
    // ]   
    const classNames = (...classes) => {
        return classes.filter(Boolean).join(' ')
    }

    return (
        <Popover className="bg-white h-16 w-full sticky top-0 z-50" onClick={() => {this.classList.toggle('closed')}}>
            <div className="mx-auto max-w-7xl px-4 sm:px-6">
                <div className="flex items-center justify-between py-auto md:justify-start md:space-x-10">
                    {/* logo */}
                    <Link to='/' className="flex justify-start items-center lg:w-0 lg:flex-1">
                        <img src={logoBB} className='w-20 h-18' alt="binarybrains logo"/>
                        <p className="text-xl cursor-pointer no-selection">BinaryBrains 🧠</p>
                    </Link>

                    {/* menu */}
                    <div className="-my-2 -mr-2 md:hidden lg:hidden xl:hidden sticky top-0 z-50">
                        <Popover.Button className="inline-flex items-center justify-end rounded-md bg-white p-2 text-gray-400 hover:bg-gray-100 hover:text-gray-500">
                            <span className="sr-only">Open menu</span>
                            <Bars3Icon className="h-6 w-6" aria-hidden="true" />
                        </Popover.Button>
                    </div>

                    {/* menu desktop */}
                    <div className="justify-center items-center hidden sm:block md:block lg:block xl:block">
                        <Popover.Group as="nav" className="hidden space-x-10 justify-center md:flex lg:flex xl:flex">
                            <Popover className="relative">
                            {({ open }) => (
                                <>
                                <Popover.Button
                                    className={classNames(
                                    open ? 'text-gray-900' : 'text-gray-500',
                                    'group inline-flex items-center rounded-md bg-white text-base font-medium hover:text-gray-900 focus:outline-none'
                                    )}
                                >
                                    <span>{ t('nav_services') }</span>
                                    <ChevronDownIcon
                                    className={classNames(
                                        open ? 'text-gray-600' : 'text-gray-400',
                                        'ml-2 h-5 w-5 group-hover:text-gray-500'
                                    )}
                                    aria-hidden="true"
                                    />
                                </Popover.Button>

                                <Transition
                                    as={Fragment}
                                    enter="transition ease-out duration-200"
                                    enterFrom="opacity-0 translate-y-1"
                                    enterTo="opacity-100 translate-y-0"
                                    leave="transition ease-in duration-150"
                                    leaveFrom="opacity-100 translate-y-0"
                                    leaveTo="opacity-0 translate-y-1"
                                >
                                    <Popover.Panel className="absolute z-10 -ml-4 mt-3 w-screen max-w-md transform px-2 sm:px-0 lg:left-1/2 lg:ml-0 lg:-translate-x-1/2">
                                    <div className="overflow-hidden rounded-lg shadow-lg ring-1 ring-black ring-opacity-5">
                                        <div className="relative grid gap-6 bg-white px-5 py-6 sm:gap-8 sm:p-8">
                                        {services.map((item, index) => (
                                            <Link to={item.href} key={index} className='-m-3 flex items-start rounded-lg p-3 hover:bg-gray-50'>
                                                <item.icon className="h-6 w-6 flex-shrink-0 text-indigo-600" aria-hidden="true" />
                                                <div className="ml-4">
                                                    <p className="text-base font-medium text-gray-900">{ t(item.name) }</p>
                                                    <p className="mt-1 text-sm text-gray-500">{ t(item.description) }</p>
                                                </div>
                                            </Link>
                                        ))}
                                        </div>
                                        <div className="space-y-6 bg-gray-50 px-5 py-5 sm:flex sm:space-y-0 sm:space-x-10 sm:px-8">
                                        {callsToAction.map((item, index) => (
                                            <div key={item.name} className="flow-root">
                                                <Link to={item.href} key={index} className="-m-3 p-3 flex items-center rounded-md text-base font-medium text-gray-900 hover:bg-gray-100">
                                                    <item.icon className="h-6 w-6 flex-shrink-0 text-gray-400" aria-hidden="true" />
                                                    <span className="ml-3">{ t(item.name) }</span>
                                                </Link>
                                            </div>
                                        ))}
                                        </div>
                                    </div>
                                    </Popover.Panel>
                                </Transition>
                                </>
                            )}
                            </Popover>

                            <Link to='/portfolio'><p className="text-base font-medium text-gray-500 hover:text-gray-900 cursor-pointer no-selection">{ t('nav_projects') }</p></Link>
                            <Link to='/team'><p className="text-base font-medium text-gray-500 hover:text-gray-900 cursor-pointer no-selection">{ t('nav_team') }</p></Link>

                            {/* <Popover className="relative">
                            {({ open }) => (
                                <>
                                <Popover.Button
                                    className={classNames(
                                    open ? 'text-gray-900' : 'text-gray-500',
                                    'group inline-flex items-center rounded-md bg-white text-base font-medium hover:text-gray-900 focus:outline-none'
                                    )}
                                >
                                    <span>{ t('nav_templates') }</span>
                                    <ChevronDownIcon
                                    className={classNames(
                                        open ? 'text-gray-600' : 'text-gray-400',
                                        'ml-2 h-5 w-5 group-hover:text-gray-500'
                                    )}
                                    aria-hidden="true"
                                    />
                                </Popover.Button>

                                <Transition
                                    as={Fragment}
                                    enter="transition ease-out duration-200"
                                    enterFrom="opacity-0 translate-y-1"
                                    enterTo="opacity-100 translate-y-0"
                                    leave="transition ease-in duration-150"
                                    leaveFrom="opacity-100 translate-y-0"
                                    leaveTo="opacity-0 translate-y-1"
                                >
                                    <Popover.Panel className="absolute left-1/6 z-10 mt-3 w-screen max-w-md -translate-x-1/2 transform px-2 sm:px-0">
                                    <div className="overflow-hidden rounded-lg shadow-lg ring-1 ring-black ring-opacity-5">
                                        <div className="relative grid gap-6 bg-white px-5 py-6 sm:gap-8 sm:p-8">
                                            {templates.map((item, index) => (
                                                <Link key={index} to={item.href} className='-m-3 flex items-start rounded-lg p-3 hover:bg-gray-50'>
                                                    <item.icon className="h-6 w-6 flex-shrink-0 text-indigo-600" aria-hidden="true" />
                                                    <div className="ml-4">
                                                        <p className="text-base font-medium text-gray-900">{ t(item.name) }</p>
                                                        <p className="mt-1 text-sm text-gray-500">{ t(item.description) }</p>
                                                    </div>
                                                </Link>
                                            ))}
                                        </div>
                                    </div>
                                    </Popover.Panel>
                                </Transition>
                                </>
                            )}
                            </Popover> */}

                            <Link to='/contact'><p className="text-base font-medium text-gray-500 hover:text-gray-900 cursor-pointer no-selection">{ t('nav_contact') }</p></Link>

                            <LanguageSwitcher />
                        </Popover.Group>
                    </div>
                </div>
            </div>

            <Transition
                as={Fragment}
                enter="duration-200 ease-out"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="duration-100 ease-in"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
            >
                {/* mobile menu */}
                <Popover.Panel focus className="absolute inset-x-0 top-0 origin-top-right transform p-2 transition md:hidden">
                    <div className="divide-y-2 divide-gray-50 rounded-lg bg-white shadow-lg ring-1 ring-black ring-opacity-5">
                        <div className="px-5 pt-5 pb-6">
                            <div className="flex items-center justify-between">
                                <div className="-mr-2">
                                    <Popover.Button className="inline-flex items-center justify-center rounded-md bg-white p-2 text-gray-400 hover:bg-gray-100 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500">
                                        <span className="sr-only">Close menu</span>
                                        <XMarkIcon className="h-6 w-6" aria-hidden="true" />
                                    </Popover.Button>
                                </div>
                            </div>

                            <div className="mt-6">
                                <Link to='/'><p className="text-base font-medium text-gray-500 hover:text-gray-900 cursor-pointer no-selection">Home</p></Link>
                            </div>

                            <div className="my-6 border-y-2 py-6">
                                <nav className="grid gap-y-8">
                                    <span className="text-base font-medium text-gray-500 no-selection">Services</span>
                                    {services.map((item, index) => (
                                        <Link to={item.href} key={index} className="flex justify-start items-center lg:w-0 lg:flex-1">
                                            <item.icon className="h-6 w-6 flex-shrink-0 text-indigo-600" aria-hidden="true" />
                                            <span className="ml-3 text-base font-medium text-gray-900">{ t(item.name) }</span>
                                        </Link>
                                    ))}
                                </nav>
                            </div>
                            
                            <div className="grid grid-cols-2 gap-y-4 gap-x-8 my-6 border-b-2 pb-6">
                                <Link to='/portfolio'><p className="text-base font-medium text-gray-500 hover:text-gray-900 cursor-pointer no-selection">Projects</p></Link>

                                <Link to='/team'><p className="text-base font-medium text-gray-500 hover:text-gray-900 cursor-pointer no-selection">Team</p></Link>
                            </div>

                            <div className="grid grid-cols-2 gap-y-4 gap-x-8 mt-6 border-b-2 pb-6">
                                <Link to='/contact'><p className="text-base font-medium text-gray-500 hover:text-gray-900 cursor-pointer no-selection">Contact</p></Link>

                                <LanguageSwitcher />
                            </div>
                            
                        </div>
                    </div>
                </Popover.Panel>
            </Transition>
        </Popover>
    )
}

export default Navbar